import * as React from "react"

import { Route, Routes } from "react-router-dom"
import { Box } from "@mui/material"
import { AdminMenu } from "./components/AdminMenu"
import { Admin } from "./components/Admin"
import PageNotFound from "./components/PageNotFound"
import { Header } from "./components/Header"
import { Footer } from "./components/Footer"


const App = () => {
  return (
    <Box display={"flex"} flexDirection={"column"} flexWrap={"nowrap"} height={"98vh"}>
      <Header flex={0} />
      <Box flex={1} height={"2000px"} overflow={"auto"} paddingTop={5}>
        <Routes>

          <Route path='/admin' element={<Admin />} >
            <Route path="/admin" element={<AdminMenu />} />
          </Route>

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Box>
      <Footer flex={0} />
    </Box>
  )
}

export default App